module.exports = __webpack_public_path__ + "static/media/1920x1080.92dc44cc.png";